(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.otto-carousel');
    if (!root) return;

    var media = root.querySelectorAll('[data-otto-video]');
    media.forEach(function (el) {
      var spinner = el.closest('.otto-product-media')?.querySelector('.otto-loading-spinner');
      if (!spinner) return;
      spinner.style.display = 'block';

      var hide = function () {
        spinner.style.display = 'none';
      };

      if (el.tagName === 'VIDEO') {
        if (el.readyState >= 3) hide();
        el.addEventListener('loadeddata', hide, { once: true });
        el.addEventListener('canplay', hide, { once: true });
        el.addEventListener('error', hide, { once: true });
      } else {
        el.addEventListener('load', hide, { once: true });
      }

      setTimeout(hide, 3000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
